import domService from '@/core/dom/dom.service';
import HttpStatus from 'http-status-codes';
import serverContextService from '@/core/serverContext.service';
import { Feature } from '@/types/apiServerContract';

const allBots = /(headlesschrome|prerender|prerender.cloud|googlebot|googlebot-mobile|duckduckbot|bingbot|baiduspider|facebookexternalhit|twitterbot|yandex|rogerbot|linkedinbot|embedly|bufferbot|quora link preview|showyoubot|outbrain|bot|crawler|80legs|ia_archiver|voyager|curl|wget|yahoo! slurp|mediapartners-google|prtg|monitis|demandbase|shopit|spider)/i;
const prerenderBots = /(prerender|prerender.cloud)/i;

function uaIsBot() {
    const userAgent = navigator.userAgent;
    const result = allBots.test(userAgent);
    return result;
}

function uaIsPrerender() {
    const userAgent = navigator.userAgent;
    const result = prerenderBots.test(userAgent);
    return result;
}

function setPrerenderRedirectUrlsIfLocationIsWrong(url: string | null) {
    const pathnameWithoutTrailingSlash = location.pathname && location.pathname.endsWith('/') && location.pathname.length > 1 ? location.pathname.slice(0, -1) : location.pathname;
    if (url && uaIsPrerender() && serverContextService.isFeatureEnabled(Feature.PrerenderRedirect) && url !== pathnameWithoutTrailingSlash) {
        if (!url.startsWith('http')) {
            const domain = location.protocol + '//' + location.host;
            const urlWithSlash = url.startsWith('/') ? url : '/' + url;
            url = domain + urlWithSlash;
        }

        domService.setPrerenderStatusCode(HttpStatus.MOVED_PERMANENTLY);
        domService.setPrerenderHeader(`Location: ${url}`);
    }
}

export default {
    uaIsBot,
    uaIsPrerender,
    setPrerenderRedirectUrlsIfLocationIsWrong
};
